import React from "react";
import { slugToCountryPathname } from "../../utils/strings";

const HomePagePresss = ({ content }) => {
  const { title, featureAward, pressLogos } = content;
  return (
    <div id="HomePagePresss">
      <div className="wrap">
        <div className="columnOne">
          <div className="pressContainer">
            <div className="title">{title}</div>
            <div className="logos">
              {pressLogos.map((logo, index) => (
                <a href={slugToCountryPathname("press-room")}>
                  <img src={logo.url} alt="pressLogo" />
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="separate" />
        <div className="columnTwo">
          <img src={featureAward.url} alt="pressLogo" />
        </div>
      </div>
    </div>
  );
};

export default HomePagePresss;
